import { JSONContentSchema } from '@littlebird/sdk';
import {
  type Extensions,
  generateHTML,
  generateJSON,
  generateText,
} from '@tiptap/core';
import { marked } from 'marked';

import { DEFAULT_EXTENSIONS } from '../extensions';

import type { JSONContent } from '../components';

export { isEmptyContent } from './content';

export function getText(
  content: JSONContent,
  extensions: Extensions = DEFAULT_EXTENSIONS
) {
  return generateText(content, extensions);
}

export function getHtml(
  content: JSONContent,
  extensions: Extensions = DEFAULT_EXTENSIONS
) {
  return generateHTML(content, extensions);
}

export function markdownToJSONContent(
  markdown: string,
  extensions: Extensions = DEFAULT_EXTENSIONS
) {
  const htmlDocument = marked.parse(markdown, { async: false });
  return generateJSON(htmlDocument, extensions);
}

export function toDocumentFrom(markdown: string): JSONContent | undefined {
  if (!markdown.length) return undefined;

  try {
    return JSONContentSchema.parse(JSON.parse(markdown));
  } catch (_error) {}

  try {
    return markdownToJSONContent(markdown);
  } catch (_error) {
    return undefined;
  }
}
